import styled from "styled-components";

const Wrapper = styled.button`
  padding: 11px 15px;
  color: ${(props) => (props.textcolor ? "var(--color-light)" : "#4C6870")};
  background: ${(props) => (props.primary ? "#05AE4B" : "transparent")};
  background-color: ${(props) => props.bg};
  width: ${(props) => props.width};
  font-size: 17px;
  font-weight: 700;
  text-align: center;
  font-family: "Lato", sans-serif;

  border: ${(props) =>
    props.border ? " 3px solid var( --app-color-dark)" : "none"};
  outline: none;
  border-radius: 4px;
  letter-spacing: 1px;

  cursor: pointer;

  :hover {
    background-color: ${(props) => props.border && "var(--color-light)"};
    color: "var(--app-color-dark)";
    /* border: ${(props) =>
      props.border && "1px solid var(--app-color-dark)"}; */
  }
`;

export default Wrapper;
